<!-- Large viewport-->
<div class="modal-body">
    <div class="d-none alert alert-success border-success text-body p-2" role="alert">
        <h6><strong translate="Settings.AccountSecuritySection.Dialog.TwoFactorAuthenticationEnabled"></strong></h6>
    </div>
    
    <div class="alert alert-primary workflowPlaceholder border-primary text-body p-3" role="alert">
        <span translate="Settings.AccountSecuritySection.Dialog.InformationAuthenticatorAppComplete"></span>
    </div>

    <div class="col-12 mb-4">
        <button class="btn default dropdown-toggle text-truncate authenticatorSecret d-block" type="button" id="dropdownMenu">
            <span class="d-block breakingRecoveryCodes">
                <em class="bi bi-files float-end" aria-hidden="true" (click)="copyToClipboard()"></em>  
                {{recoveryCodes}}
            </span>
        </button>
    </div>
    <div class="d-table pb-3 w-100">
        <span class="float-end"><button type="button" class="btn btn-sm btn-primary" (click)="close()" translate="Button.Close"></button></span>
    </div>
</div>